import { type ReactElement } from 'react';
import { cn } from '@/lib/cn';

export type PracticeControlsStripProps = {
  metronomeOn: boolean;
  onMetronomeOnChange: (value: boolean) => void;
  bpm: number;
};

// Tablet-only compact metronome strip — receives lifted state from PracticeStage.
// The drone moved to the shared <DroneControl/> side panel (#405).
export function PracticeControlsStrip({
  metronomeOn,
  onMetronomeOnChange,
  bpm,
}: PracticeControlsStripProps): ReactElement {

  return (
    <div
      data-practice-controls-strip
      className="border-t border-[var(--rule)] px-6 py-3 flex items-center gap-6 bg-[var(--bg-surface)] text-[var(--ink)]"
    >
      <div className="flex items-center gap-3">
        <span className="text-[10px] font-mono tracking-[0.18em] text-[var(--ink-3)] uppercase">Metronome</span>
        <button
          type="button"
          role="switch"
          aria-checked={metronomeOn}
          aria-label="Metronome"
          onClick={() => onMetronomeOnChange(!metronomeOn)}
          className={cn(
            'w-10 h-6 rounded-full p-0.5 transition-colors',
            metronomeOn ? 'bg-[var(--warm)]' : 'bg-[var(--bg-soft)]',
          )}
        >
          <span
            className={cn(
              'block w-5 h-5 bg-[var(--bg-surface)] rounded-full transition-transform',
              metronomeOn ? 'translate-x-4' : 'translate-x-0',
            )}
          />
        </button>
        <span className="font-display text-[20px] font-semibold tabular-nums">{bpm}</span>
      </div>
    </div>
  );
}
